export default __webpack_public_path__ + "static/media/banner.aae4c027.svg";